import { Component, inject } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
  selector: "app-error-page",
  templateUrl: "./error-page.component.html",
})
export class ErrorPageComponent {
  private router = inject(Router);
  private route = inject(ActivatedRoute);

  public errorCode;
  public message: string;

  constructor() {
    const navigation = this.router.currentNavigation();
    const state = navigation?.extras.state as { message: string };
    this.message = state?.message;

    this.route.params.subscribe((params) => {
      this.errorCode = params["id"];
    });
  }
}
